import { render, staticRenderFns } from "./DwzxbgsqBrowse.vue?vue&type=template&id=2970610e"
import script from "./DwzxbgsqBrowse.vue?vue&type=script&lang=js"
export * from "./DwzxbgsqBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports